import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

interface FormColumnHeadingProps {
  heading: string;
  subHeading: string;
}
const FormColumnHeading: React.FC<FormColumnHeadingProps> = ({ heading, subHeading }) => (
  <>
    {/* item 242 — fixed-share label column; spacing handled by FormRow's gap. Heading
        top-padding trimmed so the label lines up near the top of the field group.
        item 418 — right gutter so long subheadings never run flush into the fields
        column (Chad's Classification screenshot). */}
    <Box flexBasis={{ base: '100%', md: '22%' }} flexShrink={0} pr={{ base: 0, md: 6 }} textAlign={{ base: 'center', md: 'inherit' }}>
      <Heading size="sm" pt={2} pb={1}>{heading}</Heading>
      <Text fontSize="xs" color="brand.700" pb={{ base: 4, md: 0 }}>
        {subHeading}
      </Text>
    </Box>
  </>
);
export default FormColumnHeading;
